/**
 * Banner Parameter Handler
 * Checks for 'banner' URL parameter and stores it in localStorage
 * for use in the gatekeep component logic
 */

(function() {
  'use strict';

  /**
   * Get URL parameter value by name
   * @param {string} name - Parameter name to look for
   * @returns {string|null} Parameter value or null if not found
   */
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  /**
   * Store banner selection in localStorage
   * @param {string} bannerId - Banner ID to store
   */
  function storeBannerSelection(bannerId) {
    try {
      localStorage.setItem('selected_banner', bannerId);
      console.log('Banner selection stored:', bannerId);
    } catch (error) {
      console.warn('Failed to store banner selection in localStorage:', error);
    }
  }

  /**
   * Check for banner parameter and handle it
   */
  function handleBannerParameter() {
    const bannerParam = getUrlParameter('banner');
    
    if (bannerParam) {
      // Validate that the banner parameter is not empty and contains valid characters
      const bannerId = bannerParam.trim();
      
      if (bannerId && /^[a-zA-Z0-9_-]+$/.test(bannerId)) {
        storeBannerSelection(bannerId);
        
        // Optionally remove the parameter from URL to clean it up
        // (uncomment if you want to clean the URL after storing)
        // const url = new URL(window.location);
        // url.searchParams.delete('banner');
        // window.history.replaceState({}, document.title, url.toString());
      } else {
        console.warn('Invalid banner parameter format:', bannerParam);
      }
    }
  }

  /**
   * Get stored banner selection from localStorage
   * @returns {string|null} Stored banner ID or null if not found
   */
  function getStoredBannerSelection() {
    try {
      return localStorage.getItem('selected_banner');
    } catch (error) {
      console.warn('Failed to retrieve banner selection from localStorage:', error);
      return null;
    }
  }

  /**
   * Clear stored banner selection
   */
  function clearBannerSelection() {
    try {
      localStorage.removeItem('selected_banner');
      console.log('Banner selection cleared');
    } catch (error) {
      console.warn('Failed to clear banner selection from localStorage:', error);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleBannerParameter);
  } else {
    handleBannerParameter();
  }

  // Export functions to global scope for use by other scripts
  window.LVBannerHandler = {
    getStoredBannerSelection,
    clearBannerSelection,
    storeBannerSelection
  };
})(); 